import { Instagram, Facebook, MapPin, Phone, Clock } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-24 border-t border-emerald-300/10 bg-emerald-950/60 backdrop-blur-xl"
    >
      <div className="mx-auto max-w-7xl px-6 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-300 to-amber-600 grid place-items-center">
              <span className="font-serif text-emerald-950 text-xl font-bold">O</span>
            </div>
            <div>
              <div className="font-serif text-white text-xl">L'Oasis</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-amber-200/80">
                Restaurant
              </div>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed max-w-xs">{t.footer_tagline}</p>
        </div>

        <div className="space-y-3">
          <h4 className="font-serif text-amber-200 text-lg mb-3">{t.info_title}</h4>
          <div className="flex items-start gap-3 text-sm text-white/80">
            <MapPin className="w-4 h-4 text-amber-300/90 mt-0.5 shrink-0" />
            <span data-testid="footer-address">{t.info_address_value}</span>
          </div>
          <div className="flex items-start gap-3 text-sm text-white/80">
            <Phone className="w-4 h-4 text-amber-300/90 mt-0.5 shrink-0" />
            <a href="tel:+33467000000" data-testid="footer-phone" className="hover:text-amber-200">
              {t.info_phone_value}
            </a>
          </div>
          <div className="flex items-start gap-3 text-sm text-white/80">
            <Clock className="w-4 h-4 text-amber-300/90 mt-0.5 shrink-0" />
            <span data-testid="footer-hours">{t.info_hours_value}</span>
          </div>
        </div>

        <div>
          <h4 className="font-serif text-amber-200 text-lg mb-3">{t.info_follow}</h4>
          <div className="flex gap-3">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="glass-pill p-3 text-white hover:text-amber-200 transition"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook"
              className="glass-pill p-3 text-white hover:text-amber-200 transition"
              aria-label="Facebook"
            >
              <Facebook className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-white/50">
        © {new Date().getFullYear()} L'Oasis · {t.footer_rights}
      </div>
    </footer>
  );
}
